import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { CompositeLayer } from '@deck.gl/core';
import { getFeaturesGroupedByTileKey } from '../../../ReactLeafletMap/layers/TiledVectorLayer';
import Tile from './Tile';
var TiledVectorLayer = /*#__PURE__*/function (_CompositeLayer) {
  _inherits(TiledVectorLayer, _CompositeLayer);
  var _super = _createSuper(TiledVectorLayer);
  function TiledVectorLayer(props) {
    var _this;
    _classCallCheck(this, TiledVectorLayer);
    _this = _super.call(this, props);
    _this.getTileLayer = _this.getTileLayer.bind(_assertThisInitialized(_this));
    _this.getTilesLayers = _this.getTilesLayers.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(TiledVectorLayer, [{
    key: "getTileLayer",
    value: function getTileLayer(tile, data) {
      var _this$props, _this$props$options;
      return new Tile(this.getSubLayerProps(_objectSpread(_objectSpread({
        features: tile.features
      }, this.props), {}, {
        key: tile.key,
        tileKey: tile.key,
        featureKeysGroupedByTileKey: data.groupedFeatureKeys,
        fidColumnName: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$options = _this$props.options) === null || _this$props$options === void 0 ? void 0 : _this$props$options.fidColumnName
      })));
    }
  }, {
    key: "getTilesLayers",
    value: function getTilesLayers() {
      var _this$props2,
        _this$props2$options,
        _this$props3,
        _this$props3$options,
        _this$props4,
        _this$props5,
        _data$groupedFeatures,
        _this2 = this;
      var tiles = (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$options = _this$props2.options) === null || _this$props2$options === void 0 ? void 0 : _this$props2$options.tiles;
      var fidColumnName = (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$options = _this$props3.options) === null || _this$props3$options === void 0 ? void 0 : _this$props3$options.fidColumnName;
      var selected = (_this$props4 = this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.selected;
      var uniqueLayerKey = (_this$props5 = this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.uniqueLayerKey;
      var data = getFeaturesGroupedByTileKey(uniqueLayerKey, tiles, fidColumnName, selected);
      return data === null || data === void 0 ? void 0 : (_data$groupedFeatures = data.groupedFeatures) === null || _data$groupedFeatures === void 0 ? void 0 : _data$groupedFeatures.map(function (t) {
        return _this2.getTileLayer(t, data);
      });
    }
  }, {
    key: "renderLayers",
    value: function renderLayers() {
      var tilesLayers = this.getTilesLayers();
      return [tilesLayers];
    }
  }]);
  return TiledVectorLayer;
}(CompositeLayer);
export default TiledVectorLayer;